module.exports = __webpack_public_path__ + "img/logo-footer.913dac06.svg";